// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.footer {
    /* height: 100px; */
    margin-top: auto;
    background-color: #000;
    color: #fff;
}

.footer__container {
    padding-bottom: 100px;
}

.footer-row {
    margin: 0 auto;
    max-width: 1200px;
}

.footer-row__1 {
    margin: 0 auto;
    max-width: 1200px;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.footer__logo-text {
    padding: 0px;
}

.footer__logo {
    text-align: end;
    padding-left: 0px;
    padding-right: 2rem;
}

.footer__logo img {
    /* height: 70px; */
    width: 100%;
    height: auto;
}

.footer__text {
    padding-left: 2rem;
    text-align: start;
    font-size: 14px;
    border-left: 1px solid #fff;
}

.footer__partners {
    text-align: right;
    align-items: center;
    padding-right: 0px;
}

.footer__partners img {
    /* height: 70px; */
    height: 80px;
}

.footer-row span {
    text-align: start;
}



@media (max-width: 1220px) {
    .footer__logo {
        padding-left: 2rem;
        margin: auto 0;
    }
}

@media (max-width: 992px) {
    .footer__logo {
        margin: auto 0;
    }
    
    .footer__logo img {
        height: 60px;
        width: auto;
    }

    .footer__text {
        padding-right: 2rem;
    }
    .footer__partners img {
        height: 75px;
    }
    .footer__partners {
        margin-top: 20px;
        text-align: center;
        align-items: center;
        padding-left: 0px;
    }
}

@media (max-width: 767px) {
    .footer__text {
        text-align: center;
        border-left: none;
    }
    .footer__logo {
        text-align: center;
        margin-bottom: 10px;
    }
    .footer__logo img {
        height: 75px;
    }

    .footer__partners {
        text-align: center;
    }
}

@media (max-width: 360px) {
    .footer__partners img {
        height: 60px;
    }
}
`, "",{"version":3,"sources":["webpack://./src/styles/footer.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,sBAAsB;IACtB,WAAW;AACf;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;IACf,2BAA2B;AAC/B;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,iBAAiB;AACrB;;;;AAIA;IACI;QACI,kBAAkB;QAClB,cAAc;IAClB;AACJ;;AAEA;IACI;QACI,cAAc;IAClB;;IAEA;QACI,YAAY;QACZ,WAAW;IACf;;IAEA;QACI,mBAAmB;IACvB;IACA;QACI,YAAY;IAChB;IACA;QACI,gBAAgB;QAChB,kBAAkB;QAClB,mBAAmB;QACnB,iBAAiB;IACrB;AACJ;;AAEA;IACI;QACI,kBAAkB;QAClB,iBAAiB;IACrB;IACA;QACI,kBAAkB;QAClB,mBAAmB;IACvB;IACA;QACI,YAAY;IAChB;;IAEA;QACI,kBAAkB;IACtB;AACJ;;AAEA;IACI;QACI,YAAY;IAChB;AACJ","sourcesContent":[".footer {\n    /* height: 100px; */\n    margin-top: auto;\n    background-color: #000;\n    color: #fff;\n}\n\n.footer__container {\n    padding-bottom: 100px;\n}\n\n.footer-row {\n    margin: 0 auto;\n    max-width: 1200px;\n}\n\n.footer-row__1 {\n    margin: 0 auto;\n    max-width: 1200px;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n}\n\n.footer__logo-text {\n    padding: 0px;\n}\n\n.footer__logo {\n    text-align: end;\n    padding-left: 0px;\n    padding-right: 2rem;\n}\n\n.footer__logo img {\n    /* height: 70px; */\n    width: 100%;\n    height: auto;\n}\n\n.footer__text {\n    padding-left: 2rem;\n    text-align: start;\n    font-size: 14px;\n    border-left: 1px solid #fff;\n}\n\n.footer__partners {\n    text-align: right;\n    align-items: center;\n    padding-right: 0px;\n}\n\n.footer__partners img {\n    /* height: 70px; */\n    height: 80px;\n}\n\n.footer-row span {\n    text-align: start;\n}\n\n\n\n@media (max-width: 1220px) {\n    .footer__logo {\n        padding-left: 2rem;\n        margin: auto 0;\n    }\n}\n\n@media (max-width: 992px) {\n    .footer__logo {\n        margin: auto 0;\n    }\n    \n    .footer__logo img {\n        height: 60px;\n        width: auto;\n    }\n\n    .footer__text {\n        padding-right: 2rem;\n    }\n    .footer__partners img {\n        height: 75px;\n    }\n    .footer__partners {\n        margin-top: 20px;\n        text-align: center;\n        align-items: center;\n        padding-left: 0px;\n    }\n}\n\n@media (max-width: 767px) {\n    .footer__text {\n        text-align: center;\n        border-left: none;\n    }\n    .footer__logo {\n        text-align: center;\n        margin-bottom: 10px;\n    }\n    .footer__logo img {\n        height: 75px;\n    }\n\n    .footer__partners {\n        text-align: center;\n    }\n}\n\n@media (max-width: 360px) {\n    .footer__partners img {\n        height: 60px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
